import React, { useState } from "react";
import { Dialog } from '@mui/material';
import { texts } from "../../general/texts";
import OtpInput from 'react-otp-input';
import colors from "../../colors";
import { useDispatch, useSelector } from "react-redux";
import { sendGeneralRequest } from "../../../features/generalRequest";
import { selectGlobalDataState, setGeneralMessage } from "../../../features/global/globalDataSlice";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useNavigate } from "react-router-dom";

const CreatePinDialog = ({ isDialogOpened, handleClose }) => {
    const [OTP, setOTP] = useState('');
    const [changeBg, setChangeBg] = useState(false);
    const dispatch = useDispatch()
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const isSmallScreen = useMediaQuery('(max-width:600px)');
    const navigate = useNavigate()

    const handleChange = (otpValue) => {
        setOTP(otpValue);
        if (otpValue.length === 6) {
            setChangeBg(true);
        } else {
            setChangeBg(false);
        }
    };

    const handleCloseDialog = (event, reason) => {
        if (reason !== "backdropClick") {
            handleClose();
            navigate('/dashboard')
        }
    };

    const confirmCode = () => {
        dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token, pin: OTP.toUpperCase() }, baseUrlKey: 'auth', endpoint: 'UpdatePin' })).then(response => {
            if (response.payload.response.success) {
                dispatch(setGeneralMessage({ type: 'success', message: 'PIN-i u vendos me sukses!' }))
                localStorage.setItem('hasPinRegistered', true)
                handleCloseDialog(null, "close")
            }
        })
    }

    return (
        <Dialog
            open={isDialogOpened}
            onClose={handleCloseDialog}
            disableEscapeKeyDown={true}
            keepMounted
            fullWidth
            maxWidth="lg"
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            PaperProps={{
                style: {
                    borderRadius: '20px',
                    width: '550px',
                    height: 'auto',
                    padding: '30px',
                    zIndex: 888,
                },
            }}
        >
            <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                <span style={{ fontSize: '30px', fontWeight: 700, color: colors.darkBlue, marginBottom: '50px', marginTop: '20px' }}>
                    {texts['title-registration-pin']}
                </span>
                <OtpInput
                    value={OTP}
                    onChange={handleChange}
                    numInputs={6}
                    isInputNum
                    inputStyle={{
                        width: '2rem',
                        height: '2.5rem',
                        borderTop: 'none',
                        borderLeft: 'none',
                        outline: 'none',
                        borderRight: 'none',
                        fontFamily: 'GerberaLight',
                        borderBottom: '1px solid gray',
                        transition: 'border-color 0.2s ease-in-out',
                        color: colors.darkBlue,
                        fontSize: '1.5rem',
                        paddingBottom: '3%',
                        height: '60%',
                        marginBottom: '50px',
                        textAlign: 'center',
                        marginRight: '0.5rem',
                    }}
                    renderInput={(props) => <input {...props} type="password" />}
                />
                <button
                    onClick={confirmCode}
                    disabled={!changeBg}
                    style={{
                        width: '260px',
                        height: '40px',
                        fontSize: '15px',
                        fontWeight: 700,
                        border: changeBg ? '1px solid orange' : 'none',
                        borderRadius: '10px',
                        color: changeBg ? colors.orange : colors.darkBlue,
                        background: changeBg ? colors.lightOrange : colors.lightGray,
                        cursor: changeBg ? 'pointer' : 'default',
                    }}
                >
                    {texts['button-confirm']}
                </button>
            </div>
        </Dialog>
    );
};

export default CreatePinDialog;
